import React, { useState } from 'react';

import { Thead, Tbody, Tr, Th } from 'xpi-black-ui/Common/Table';

import Leg from './Leg';
import ModalDialog from '../../../../../ModalDialog';

import { Table } from './styles';

function Legs({ legs, updateLeg, removeLeg, typeStrike, updatePrice }) {
  const [legRemove, setLegRemove] = useState(undefined);
  const [callBackChangeLeg, setCallBackChangeLeg] = useState(null);
  const [showModalChangeLeg, setShowModalChangeLeg] = useState(false);

  const willChangeValue = (callback) => {
    if (updatePrice) {
      setShowModalChangeLeg(true);
      setCallBackChangeLeg(() => callback);
    }
    else {
      callback();
    }
  }

  return (
    <>
      <Table>
        <Thead>
          <Tr>
            <Th style={{ width: "110px" }}>Ativo</Th>
            <Th style={{ width: "90px" }}>Spot</Th>
            <Th style={{ minWidth: "130px" }}>Natureza</Th>
            <Th style={{ width: "110px" }}>Quantidade</Th>
            <Th style={{ minWidth: "110px" }}>Tipo</Th>
            <Th>Vencimento</Th>
            <Th width="125px">Strike R$</Th>
            {!legs[0]?.reverse && <Th width="125px">Strike %</Th>}
            {/* <Th className="invisible">Nova Perna</Th>
            <Th className="invisible">Delete</Th> */}
          </Tr>
        </Thead>
        <Tbody>
          {legs?.map((leg) => (
            <Leg
              key={leg.id}
              leg={leg}
              updateLeg={updateLeg}
              typeStrike={typeStrike}
              willChangeValue={willChangeValue}
            />
          ))}
        </Tbody>
      </Table>
      <ModalDialog
        width="340px"
        height="auto"
        titlePrimaryButton="Excluir"
        titleSecondaryButton="Cancelar"
        open={legRemove !== undefined}
        onClose={() => setLegRemove(undefined)}
        title="Tem certeza de que deseja excluir essa perna da cotação?"
        actionPrimaryButton={() => { removeLeg(legRemove); setLegRemove(undefined); }}
      />
      <ModalDialog
        width="340px"
        height="auto"
        open={showModalChangeLeg}
        titlePrimaryButton="Confirmar"
        titleSecondaryButton="Cancelar"
        onClose={() => setShowModalChangeLeg(false)}
        title="Tem certeza de que deseja fazer essa alteração? Em caso de positivo, será necessário atualizar o preço da cotação."
        actionPrimaryButton={() => { callBackChangeLeg(); setShowModalChangeLeg(false) }}
      />
    </>
  );
}

export default Legs;
